<template>
  <div class="videoAnalysisMap">
    <my-map ref="mapRef" :showOperationPoint="true"></my-map>
    <div class="search">
      <el-form ref="ruleFormRef" :model="tableParams" :inline="true">
        <el-form-item>
          <el-select v-model="tableParams.status">
            <el-option
              v-for="item in lineStatus"
              :key="item.key"
              :label="item.label"
              :value="item.key"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="tableParams.name"
            placeholder="请输入资源名称"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div></div>
  </div>
</template>

<script>
import {
  defineComponent,
  nextTick,
  reactive,
  toRefs,
  watchEffect,
  watch,
  ref,
  onMounted,
} from "vue";
import MyMap from "@/components/map/MyMap.vue";
import { queryRealVideoTree } from "@/api/videoControl/videoApi.js";
export default defineComponent({
  name: "videoAnalysisMap",
  components: { MyMap },
  props: {},
  setup(props) {
    const state = reactive({
      tableParams: {
        status: "0",
        name: "",
      },
      lineStatus: [
        { label: "全部资源", key: "0" },
        { label: "在线解析任务资源", key: "1" },
        { label: "未分配解析任务资源", key: "2" },
      ],
    });
    const mapRef = ref();
    // 获取区域树中摄像头数据
    const queryRealVideoTreeAsync = async () => {
      const res = await queryRealVideoTree();
      state.videoData = res.cameraBaseDtls;
      setTimeout(() => {
        pointInfoArray(res.cameraBaseDtls);
      }, 300);
    };
    // 添加接口中数据点位
    const pointInfoArray = (list) => {
      const array = list.filter((item, index) => {
        if (item.longitude && item.latitude) {
          return item;
        }
      });
      const newList = array.map((element, index) => {
        const pointInfo = {
          name: "",
          item: element,
          id: 1,
          type: 1,
          showType: 2,
          poiType: 3408,
          location: [],
          click: (e) => {
            nextTick(() => {
              state.mapDataItem = element;
            });
          },
        };
        pointInfo.id = index + 1;
        // pointInfo.poiType = element.type;
        pointInfo.location[0] = parseFloat(element.longitude);
        pointInfo.location[1] = parseFloat(element.latitude);
        return pointInfo;
      });
      nextTick(() => {
        console.log(newList);
        console.log(mapRef);
        mapRef.value && mapRef.value.loadMarker(newList);
      });
    };
    queryRealVideoTreeAsync();
    return {
      ...toRefs(state),
      mapRef,
    };
  },
});
</script>

<style lang="scss" scoped>
.videoAnalysisMap {
  width: 100%;
  height: 100%;
  position: relative;
  .search {
    position: absolute;
    top: 8px;
    left: 48px;
    z-index: 5;
    .el-form-item {
      width: 170px;
      margin-right: 0px;
    }
  }
}
</style>
